import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { ParserService } from '@app/services/parser.service';
import { ParseOptions } from '@app/expressions/parser';
import { APP_CONFIG, AppConfigModel } from '@app/models/app-config.model';

@Pipe({
  name: 'parse',
  standalone: true,
  pure: true,
})
export class ParsePipe implements PipeTransform {
  constructor(
    private readonly parser: ParserService,
    @Optional() @Inject(APP_CONFIG) private readonly config?: AppConfigModel
  ) {}

  transform<T>(
    value: T,
    context: Record<string, unknown>,
    options?: ParseOptions
  ) {
    return this.parser.parse(value, {
      context,
      log: !this.config?.PRODUCTION && console.debug,
      ...options,
    });
  }
}
